<template>
    <div class="container">
      <v-header ref="headerDivchild" :key="nowActive" :nowActivePor="nowActive" @isShowLoginPopupClick="isShowLoginPopupClick"></v-header>
      <main>
          <keep-alive>
            <router-view @isNavClick="isNavClick" @isShowLoginPopupClick="isShowLoginPopupClick" class="mainContent" v-if="$route.meta.keepAlive"></router-view>
          </keep-alive>
          <router-view @isNavClick="isNavClick" @isShowLoginPopupClick="isShowLoginPopupClick" class="mainContent" v-if="!$route.meta.keepAlive"></router-view>
      </main>
      <el-dialog
        class="loginMsgDialog"
        :visible.sync="loginMsgDialogShow"
        :close-on-click-modal="false"
        width="360px"
        top="calc(50vh - 201px)"
        :show-close="false">
            <section class="detailItemView">
              <img class="closeIcon" @click="loginMsgDialogCloseBtn" src="../../static/images/popup-close.png" />
                <v-loginPopup :fromPath="fromPath" @loginMsgDialogCloseBtn="loginMsgDialogCloseBtn"></v-loginPopup>
            </section>
      </el-dialog>
    </div>
</template>

<script>
import vHeader from '../components/headerDiv'
import vLoginPopup from '../components/loginPopup'
export default {
  name: 'home',
  components: {
    vHeader,
    vLoginPopup
  },
  data () {
    return {
      nowActive: '', // 左标显示或隐藏
      loginPopupShow: '', // 登录弹窗显示或隐藏
      loginMsgDialogShow: false,
      fromPath: '' // 登录后跳转路径
    }
  },
  created () {
  },
  methods: {
    // 这个函数+页面中的‘this.$emit('isnavClick', 1)’作用是：设置在哪个tab)
    isNavClick (status) {
      this.nowActive = status
      console.log(status)
    },
    // 这个函数+页面中的‘this.$emit('isShowLoginPopupClick', false)
    isShowLoginPopupClick (status, fromPath) {  //参数1:登录弹窗是否谈起  参数2: 跳转页面
      this.loginMsgDialogShow = status
      if(fromPath) {
          this.fromPath = fromPath
      }
      console.log(status)
    },
    loginMsgDialogCloseBtn(val) {
        this.loginMsgDialogShow = false
        if(val == 'loginPopupChild') {
          this.$refs.headerDivchild.childUpdateUserMsgFn()
        }
    }
  }
}
</script>

<style scoped lang="less">
  .container {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    -ms-flex-direction: column;
    flex-direction: column;
    // height: 100vh;
    // min-width: 1200px;
    main {
      display: flex;
      justify-content: center;
      flex: 1;
      height: calc(100vh - 98px);
      overflow-y: auto;
      // background: #ccc;
      .mainContent {
        width: 100%;
        background: #060714;
      }
    }
  }
</style>
<style lang="less">
.loginMsgDialog {
    .el-dialog__wrapper {
      background: rgba(0, 0, 0, .6);
    }
    .el-dialog {
      height: 402px;
      background: #FFFFFF;
      border-radius: 16px;
    }
    .closeIcon {
        position: absolute;
        top: 30px;
        right: 30px;
        width: 28px;
        height: 28px;
        cursor: pointer;
    }
}
.el-dialog__header {
    padding: 56px 0 0 0 !important;
}
.el-dialog__body {
    padding: 0 35px;
    color: #606266;
    font-size: 14px;
    word-break: break-all;
}
</style>